import { PageId } from './src-types-pageId.js';
import { PricePresentationType } from './src-types-prices.js';

const DisplayStrategyConfig = {
  [PageId.CorePDP]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.TotalPrice
  },
  [PageId.LatPDP]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.TotalPrice
  },
  [PageId.PDP]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.TotalPrice
  },
  [PageId.Gallery]: {
    legacy: PricePresentationType.QtyFromPrice,
    current: PricePresentationType.TotalPrice
  },
  [PageId.ChecksQuickView]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.RecommendationLane]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.RecommendationLaneWithQuantity]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.PDC]: {
    legacy: PricePresentationType.RawPrice,
    current: PricePresentationType.TotalPrice
  },
  [PageId.Category]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.HomePage]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.SearchPages]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.SearchDesignTiles]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.TotalPrice
  },
  [PageId.GalleryQuickView]: {
    legacy: PricePresentationType.QtyFromPrice,
    current: PricePresentationType.TotalPrice
  },
  [PageId.Favorites]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.LaunchMyBusiness]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  },
  [PageId.QuickProductFlowFlyout]: {
    legacy: PricePresentationType.PriceForQtyUnits,
    current: PricePresentationType.TotalPrice
  },
  [PageId.FavoritesTemplateSection]: {
    legacy: PricePresentationType.QtyStartingAtPrice,
    current: PricePresentationType.FromPrice
  }
};

export { DisplayStrategyConfig };
//# sourceMappingURL=src-constants-priceDisplayStrategy.js.map
